import { useInvoiceTask } from '@/hooks/api/1840_invoice_task';
import { TeamMemberLogic } from '@/hooks/api/models/logics';
import { toastError } from '@/lib/toast';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export const RequireInvoiceTask = ({ children }: Props) => {
  const location = useLocation();
  const { meTeamMember } = useCurrentTeamMember();
  const { identifier, team_id, sales_order_id, invoice_task_id } = useParams();
  const { data, status } = useInvoiceTask({
    identifier: identifier!,
    team_id: Number(team_id!),
    sales_order_id: Number(sales_order_id!),
    id: Number(invoice_task_id!),
  });
  const { invoiceTask, setInvoiceTask } = useCurrentInvoiceTask();

  useEffect(() => {
    if (data) {
      setInvoiceTask((_) => data);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  // backoffice権限のみの場合
  if (meTeamMember && TeamMemberLogic.hasBackofficeOnlyRole(meTeamMember!)) {
    // urlがプロジェクト配下のurlの場合は、backoffice配下のurlに遷移
    if (location.pathname.startsWith(`/w/${identifier}/teams/`)) {
      return <Navigate replace to={`/w/${identifier}/backoffice/teams/${team_id}/sales_orders/${sales_order_id}/invoice_tasks/${invoice_task_id}`} />;
    }
  }

  if (invoiceTask) {
    return <>{children}</>;
  }

  return <></>;
};
